import React from 'react';
import SchemeListNew from '../features/schemes/SchemeListNew';

// import Breadcrumbs from '../components/Breadcrumbs';
import { Container } from 'react-bootstrap';

export default function UserFundSchemes({ filters = []}) {
  
  return (
    <div className="container-fluid" >
      <SchemeListNew filters={filters} apiURL='/my-fund-schemes' 
                     isAddToWatchlistApplicable={true} schemeListTitle='User Selected Funds Schemes -'/>
    </div>
  );
}